import update from 'immutability-helper';

import {
  SET_TOOGLE_FILTER_STATE,
  SET_UPDATE_FILTER_ACTIVE_OPTION,
  SET_FILTER_SHOW_ALL_OPTIONS,
  SET_FILTER_RANGE_VALUES,
  SET_FILTER_VALUES,
} from './constants';

/**
 * updates element in array with `slug` matching given
 */
update.extend('$updateBySlug', (value, arr) =>
  update(
    arr,
    Object.keys(value).reduce((result, itemSlug) => {
      const index = arr.findIndex(({ slug }) => slug === itemSlug);
      if (index !== -1) result[index] = value[itemSlug];
      return result;
    }, {}),
  ),
);

export default function (state = [], action) {
  switch (action.type) {
    case SET_TOOGLE_FILTER_STATE: {
      const { slug, isOpen } = action;
      return update(state, {
        $updateBySlug: {
          [slug]: {
            isOpen: { $set: !isOpen },
          },
        },
      });
    }
    case SET_FILTER_VALUES: {
      const { payload } = action;
      return payload;
    }
    case SET_UPDATE_FILTER_ACTIVE_OPTION: {
      const { filterSlug, optionSlug, payload } = action;
      return update(state, {
        $updateBySlug: {
          [filterSlug]: {
            options: {
              $updateBySlug: {
                [optionSlug]: {
                  isChecked: { $set: payload },
                },
              },
            },
          },
        },
      });
    }
    case SET_FILTER_SHOW_ALL_OPTIONS: {
      const { slug, count } = action;
      return update(state, {
        $updateBySlug: {
          [slug]: {
            optionsToShowCount: { $set: count },
          },
        },
      });
    }
    case SET_FILTER_RANGE_VALUES: {
      const { slug, valueFrom, valueTo } = action;
      return update(state, {
        $updateBySlug: {
          [slug]: {
            ...(typeof valueFrom !== 'undefined' ? { valueFrom: { $set: valueFrom } } : {}),
            ...(typeof valueTo !== 'undefined' ? { valueTo: { $set: valueTo } } : {}),
            used: { $set: true },
          },
        },
      });
    }
    default:
      return state;
  }
}
